import { useSelector } from "react-redux";
import styled from "styled-components";
import theme from "../../theme/theme";
import StrategyItem from "./StrategyItem";

const Wrapper = styled.div`
  background-color: ${theme.colors.white};

  .linebreak {
    margin: 15px 0;
    width: 100%;
    border-bottom: 1px solid #e7eaed;
  }
`;

const StrategiesList = () => {
  const { dashboardData } = useSelector((state) => state.user);
  const data = dashboardData?.strategies;

  return (
    <Wrapper>
      <ul>
        {data
          .filter((data) => data.isSelected)
          .map((strategy, i) => (
            <li key={i}>
              <StrategyItem strategy={strategy} />

              <div className="linebreak"></div>
            </li>
          ))}
      </ul>
    </Wrapper>
  );
};

export default StrategiesList;
